import {
  FileIcon,
  ImageIcon,
  PdfIcon,
  SequenceIcon,
  ThreeDimensionsIcon,
  VideoIcon,
} from '@/icons';

export const ICONS = {
  SEQUENCE: SequenceIcon,
  SCAN: ThreeDimensionsIcon,
  IMAGE: ImageIcon,
  VIDEO: VideoIcon,
  PDF: PdfIcon,
  DOCUMENT: FileIcon, // TODO
  OTHER: FileIcon,
};
